export default "__VITE_ASSET__Bq9Vbynv__"